module.exports = __webpack_public_path__ + "static/media/img-card.57246b7a.jpg";